// src/with-layout.tsx
import React from "react";
import Layout from "./layout";

const withLayout = ({element, props}) => {
  return <Layout {...props}>{element}</Layout>;
};

export default withLayout;
